import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from '@yonderland/andes-react';
import { HtmlInclude } from '../../components/common/html-include/HtmlInclude';
export const ListerSeoTextContainer = ({ seoTextInclude }) => {
    if (!seoTextInclude || seoTextInclude.trim().length < 1) {
        return null;
    }
    return (_jsx(Box, { paddingBlock: { base: '4', lg: '6' }, children: _jsx(HtmlInclude, { htmlFragment: seoTextInclude }) }));
};
